module.exports = __webpack_public_path__ + "img/study_statitle_bg2.6c0c24e6.png";